import * as React from "react";

export interface IContactUsCompoProps {}

export function ContactUsCompo(props: IContactUsCompoProps) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="contact-main-componet">
        <div className="top-banner-contact">
          <img
            src="https://ddappcdn.techxr.co/techxrWeb/contact/pexels-fauxels-3183150.jpg"
            alt=""
          />
          <div className="inner_overlap-contact">
            <h2>Contact Us</h2>
            <p>For any query, Reach out to us at give below mediums.</p>
          </div>
        </div>

        <div className="contact-body py-100">
          <div className="common-container">
            <div className="common-row">
              <div className="common-col-4 common-md-6 common-xs-12 mb-30">
                <div className="inner_contact_body">
                  <div className="contact-icon">
                    <img
                      src="https://ddappcdn.techxr.co/techxrWeb/contact/phone.png"
                      alt=""
                    />
                  </div>
                  <h3>Phone</h3>
                  {/* <p className="mb-0">Call / Whatsapp: +91 9109131271 </p> */}
                  <p>
                    For SenseXR Controller <br /> related queries -
                    <span>+91 9109131271</span>
                  </p>

                  {/* <p>
                    For AR-VR Course <br /> related queries -
                    <span>+91 9109131271 </span>
                  </p> */}
                </div>
              </div>
              <div className="common-col-4 common-md-6 common-xs-12 mb-30">
                <div className="inner_contact_body">
                  <div className="contact-icon">
                    <img
                      src="https://ddappcdn.techxr.co/techxrWeb/contact/address.png"
                      alt=""
                    />
                  </div>
                  <h3>Address</h3>
                  <p>
                    SF-15 Second Floor Aakriti Business Centre, Aakriti Eco
                    City, Bhopal India - 462026
                  </p>
                  <a
                    href="https://goo.gl/maps/8vBMgN5TdYiuH9Kq6"
                    target="blank"
                  >
                    Go To Map
                  </a>
                </div>
              </div>
              <div className="common-col-4 common-md-6 common-xs-12 mb-30">
                <div className="inner_contact_body">
                  <div className="contact-icon">
                    <img
                      src="https://ddappcdn.techxr.co/techxrWeb/contact/email.png"
                      alt=""
                    />
                  </div>
                  <h3>Email</h3>
                  <p>sensexr@techxr.co</p>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="contact-body mb-50">
          <div className="common-container">
            <div className="common-row">
              <div className="common-col-6 common-md-6 common-xs-12 m-auto">
                <div className="iframe_contact">
                <iframe width='610px' height='800px' src='https://bigin.zoho.in/crm/WebFormServeServlet?rid=99b6d6342048f3923eaf4837a057e4741c6e6eeacdda2d78a3d874b9b1f2bb8497eb65dc294ebf47dbe19c5bd4886f22gida6d3f72e6c1db885dfb05c1c2bdb9d91ef4f17f258b8fef05a19b767afbbbfb3'></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
}
